import React from "react";

export default function Interests() {
    return (
        <div className="interests">
            <h4 className="header">Interests</h4>
            <p className="content">
                Football fan and an avid supporter, Photography enthusiast, Loves travelling,
                watching movies and listening to all kinds of songs
            </p>
        </div>
    )
}